import React, { useState, useEffect } from "react";
import Loader from "../../../Common/Loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import ExcelJS from "exceljs";
import { Formik, Form, Field } from "formik";
import { formattedDate, getCurrentDateTime, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";
const GvpInnerExistingReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const { data, formatDate,shiftName } = location.state || {};
  const navigate = useNavigate();
  const [gvpList, setGvpList] = useState(data);

  const scvReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "100px",
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["zoneName"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Circle",
      selector: (row) => row["circleName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["circleName"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Ward",
      selector: (row) => row["wardName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["wardName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    
    {
      name: <>Collection Point Code</>,
      selector: (row) => row["collectionPointCode"],
      cell: (row) => <span>{row["collectionPointCode"]}</span>,
      sortable: true,
      // width:'120px'
    },
    {
      name: <>Collection Point Name</>,
      selector: (row) => row["collectionPointName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["collectionPointName"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: <>Collection Point Type</>,
      selector: (row) => row["collectionPointTypeName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["collectionPointTypeName"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "latitude",
      selector: (row) => row["latitude"],
      cell: (row) => (
        <span
        // style={{ color: "blue" }}
        >
          {row["latitude"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "longitude",
      selector: (row) => row["longitude"],
      cell: (row) => <span> {row["longitude"]}</span>,
      sortable: true,
    },
  ];

  // const downloadAsExcel = () => {
  //   const ws = XLSX.utils.json_to_sheet(data);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "gvpInnerExisting");
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  //   });
  //   const downloadLink = document.createElement("a");
  //   downloadLink.href = URL.createObjectURL(data);
  //   downloadLink.download = "gvpInnerExisting.xlsx";
  //   downloadLink.click();
  // };

  // const downloadAsExcel = () => {
  //   if (!data) return; // Check if data is initialized
  //   // Add serial number to each item in the collection details
  //   const dataWithSerialNumber = data.map((item, index) => ({
  //     ...item,
  //     's.no': index + 1,
  //   }));

  //   // Filter out only the data corresponding to the headers displayed in the table component
  //   const filteredData = dataWithSerialNumber.map(item => ({
  //     's.no': item['s.no'],
  //     zone: item.zoneName,
  //     circle: item.circleName,
  //     ward: item.wardName,
  //     Point: item.collectionPointName,
  //     latitude: item.latitude,
  //     longitude: item.longitude,
  //   }));

  //   const ws = XLSX.utils.json_to_sheet(filteredData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "GVPsExistingClearanceReport");
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const excelBlob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
  //   const downloadLink = document.createElement("a");
  //   downloadLink.href = URL.createObjectURL(excelBlob);
  //   downloadLink.download = "gvpInnerExisting.xlsx";
  //   downloadLink.click();
  // };
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `GVPs Shift Target as on ${formatDate?formattedDate(formatDate):getCurrentISTDate()} - ${shiftName} - (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add row for download date and time
    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont; // Set style for the cell
    dateTimeRow.getCell(3).alignment = { horizontal: "center" }; // Center align the cell content
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        // Apply styles to download date and time cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add row for cumulative heading report
    const cumulativeHeadingRow = worksheet.addRow([
      "",
      "",
      cumulativeHeadingReport,
      "",
      "",
    ]);
    worksheet.mergeCells(2, 3, 2, 6);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 7) {
        // Apply styles to cumulative heading report cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Circle",
      "Ward",
      "Collection Point Code",
      "Collection Point Name",     
      "Collection Point Type",     
      "Latitude",
      "Longitude",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 14) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Add data rows
    gvpList.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.zoneName?? "N/A",
          item.circleName?? "N/A",
          item.wardName ?? "N/A",
          item.collectionPointCode?? "N/A",
          item.collectionPointName?? "N/A",
          item.collectionPointTypeName?? "N/A",                    
          item.latitude?? "N/A",
          item.longitude?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 12) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 25 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 25 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "GVPsShiftTargetInnerReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  const filterFields = {
    searchCircle: "",
    searchCollectionPointCode: "",
    searchCollectionPointName: "",
  };

  const searchReportedAtVehicleHandler = (values) => {
    const termCircle = values.searchCircle
      ? values.searchCircle.toLowerCase()
      : "";
    const termCollectionPointCode = values.searchCollectionPointCode
      ? values.searchCollectionPointCode.toLowerCase()
      : "";
    const termCollectionPointName = values.searchCollectionPointName
      ? values.searchCollectionPointName.toLowerCase()
      : "";

    const filteredData = data.filter((item) => {
      const circleName = item?.circleName
        ? String(item.circleName).toLowerCase()
        : "";
      const collectionPointCode = item.collectionPointCode
        ? String(item.collectionPointCode).toLowerCase()
        : "";
      const collectionPointName = item?.collectionPointName
        ? String(item.collectionPointName).toLowerCase()
        : "";

      const matchesCircle = !termCircle || circleName.includes(termCircle);
      const matchesCollectionPointCode =
        !termCollectionPointCode ||
        collectionPointCode.includes(termCollectionPointCode);
      const matchesCollectionPointName =
        !termCollectionPointName ||
        collectionPointName.includes(termCollectionPointName);

      return (
        matchesCircle &&
        matchesCollectionPointCode &&
        matchesCollectionPointName
      );
    });
    setGvpList(filteredData);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="card mt-3">
              <div className="card-body">
                <div className="page-header">
                  <div className="d-flex justify-content-between ALIGN-ITEMS-CENTER mt-3">
                    <Formik initialValues={filterFields}>
                      {({ handleChange, values }) => (
                        <Form>
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group">
                                <Field
                                  name="searchCircle"
                                  placeholder="Search Circle"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchCircle: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <Field
                                  name="searchVehicle"
                                  placeholder="Search GVP Point"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchCollectionPointName: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <Field
                                  name="searchDriverName"
                                  placeholder="Search GVP Code"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchCollectionPointCode: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                    <div className="d-flex">
                        <div>
                          <button
                            className="btn btn-secondary "
                            onClick={() => navigate(-1)}
                          >
                            Back
                          </button>
                        </div>
                        <div>
                          <button
                            className="btn btn-excel "
                            onClick={downloadAsExcel}
                          >
                            <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                            Excel
                          </button>
                          
                      </div>
                    </div>
                  </div>
                </div>
                <div className="top-header">
                  <span> GVPs Shift Target as on {formatDate?formattedDate(formatDate):getCurrentISTDate()} - {shiftName} - (at {getCurrentDateTime1()})</span>
                
                </div>

                <CustomDataTable data={gvpList} columns={scvReportColumns} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

export default GvpInnerExistingReport;
